<template>
  <div class="flow-common-form-approval">
    <form-create ref="formCreate"
                 :rule="formRule"
                 :option="formOption"
                 :value="formData" />
  </div>
</template>

<script>
export default {
  name: 'FlowCommonFormApproval',
  props: {
    formJson: {
      type: String,
      required: true
    },
    formData: Object
  },
  computed: {
    formOpts () {
      return JSON.parse(this.formJson)
    },
    formRule () {
      return this.formOpts.rule || []
    },
    formOption () {
      const option = this.formOpts.option || {}
      return {
        ...option,
        submitBtn: false,
        resetBtn: false,
        form: {
          ...(option.form || {})
        },
        global: {
          '*': {
            props: {
              readonly: true
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.flow-common-form-approval {
  padding: 16px;
}
</style>
